import * as React from 'react'
import { BottomBar, type BottomBarButton } from '../../../app-core/lib/page/BottomBar'
import { Base_commonDeps } from '../Base/Base.commonDeps'
import { createMutableCallback } from '../../../shared/lib/mutableCallback.no-deps'
import { Rout_toSearch } from '../Rout/Rout.search'
import { Rout_toTodo } from '../Rout/Rout.todo'
import { WF_openWorkflowDialog } from '../WF/WF.openWorkflowDialog'
import { Rout_toNotifications } from '../Rout/Rout.notification'
import { DS_Listen } from '../DS/DS.ui.Listen'
import type { FlowContinuationId } from '../../../app-core/lib/flow/FlowReport'
import { Rout_toUserActions } from '../Rout/Rout.action'
import { initWebPushNotifications } from '../WebPushNotifications'
import { Plat_isCordova } from '../Plat/Plat.device'

export function Navi_bottomBar(active: BottomBarButton, createContinuation?: () => Promise<FlowContinuationId>) {
    return DS_Listen(
        ({ unreadNotifications }) => ({ unreadNotifications }),
        ({ unreadNotifications }) => (
            <BottomBar
                deps={Base_commonDeps()}
                active={active}
                routeToTodoTopPage={Rout_toTodo}
                routeToTodoSubpage={() => useTodoSubpage(Rout_toTodo)}
                routeToSearchTopPage={Rout_toSearch}
                routeToSearchSubpage={() => useSearchSubpage(Rout_toSearch)}
                routeToNotificationsPage={() => {
                    Rout_toNotifications()
                    if (!Plat_isCordova()) {
                        initWebPushNotifications()
                    }
                }}
                routeToActionsPage={() => Rout_toUserActions()}
                startWorkflow={() => WF_openWorkflowDialog(createContinuation)}
                notificationsCount={unreadNotifications.length}
            />
        )
    )
}

/**
 * Mutable singleton callbacks for the bottom bar buttons
 */
const [, setTodoSubpage, useTodoSubpage] = createMutableCallback()
const [, setSearchSubpage, useSearchSubpage] = createMutableCallback()

export const Navi_setTodoSubpage = setTodoSubpage
export const Navi_setSearchSubpage = setSearchSubpage
